import { Pipe, PipeTransform } from '@angular/core';
import NP from 'number-precision'
import { notNullUndefined } from 'src/app/helpers/utils';

@Pipe({
  name: 'convertMeterToKm'
})
export class ConvertMeterToKmPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    return notNullUndefined(value)? NP.divide(value,1000).toFixed(2):'N/A'
  }

}
